<forge-select *ngIf="!useDualList" multiple="true" [disabled]="isViewOnly" [label]="Label" [name]="Name"
              attr.telemetry="Submission-{{Label}}" (change)="fireValueChanged($event)" [invalid]="isInvalid"
              [required]="isRequired" [(ngModel)]="selected" [value]="selected">
    <forge-option *ngFor="let item of options" [value]="item.Key">{{item.Value}}</forge-option>
    <span *ngIf="!dense" slot="support-text" [hidden]="!hint">{{hint}}</span>
    <span *ngIf="!dense" slot="support-text" class="error-red">{{error}}</span>
</forge-select>
<div *ngIf="useDualList">
    <label *ngIf="compact" for="mlt-{{Name}}" class="forge-typography--label1 compact-mode--label"
           [ngClass]="{'compact-mode--label-required': isRequired, 'compact-mode--label-invalid': error.length > 0}">{{Label}}
    </label>
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <forge-text-field class="multiselect" [required]="isRequired" [invalid]="isInvalid" style="width: 100%;"
                          [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [attr.aria-label]="Name"
                          [density]="Density" id="multiselect-text-field-{{popupId}}" role="combobox"
                          attr.aria-controls="multi-select-{{popupId}}-popover" popover-icon [popoverExpanded]="popover.open"
                          [attr.shape]="forCellEdit ? 'squared' : null">
            <input readonly class="multiselect-input popup-target" [ngModel]="selectedCount" type="text"
                   id="mlt-{{popupId}}" [required]="isRequired" [invalid]="isInvalid"
                   [disabled]="isViewOnly" (keydown)="textContainerKeydown($event)"
                   forgePopoverCloseOnBlur="true" (click)="openPopup(false)" [name]="Name"
                   attr.telemetry="Submission-{{Label}}" autocomplete="off">
            <label *ngIf="!compact && !forCellEdit" for="mlt-{{Name}}">{{Label}}</label>
            <span *ngIf="hint && !dense && !compact" slot="support-text">{{hint}}</span>
            <span *ngIf="error && !dense && !compact" slot="support-text" class="error-red">{{error}}</span>
            <forge-circular-progress *ngIf="showSpinner" class="metadata-input--spinner" slot="end">
            </forge-circular-progress>
        </forge-text-field>

        <forge-popover #popover anchor="multiselect-text-field-{{popupId}}" id="multi-select-{{popupId}}-popover"
                       placement="bottom" position-strategy="fixed" (forge-popover-toggle)="togglePopover($event)">
            <div #popupContent id="multi-select-{{popupId}}" class="popup-container" *ngIf="popover.open">
                <div class="popup-card multi-select">
                    <div fxLayout="row">
                        <div fxLayout="column" style="width: 100%;">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin: 16px 16px 0;">
                                <forge-text-field style="width: 100%;" [ngClass]="{'dense-input': compact}" [density]="Density"
                                                  show-clear (forge-text-field-clear)="clearOptionSearch()">
                                    <input #searchFilter type="text" id="searchFilter-{{Name}}" name="searchFilter-{{Name}}"
                                           class="multi-select--search-field" attr.telemetry="Search-Tree"
                                           (keydown)="trapTab($event)" attr.aria-label="search options for {{Name}}"
                                           [(ngModel)]="optionSearch" (change)="loadMoreCount = 1" autocomplete="off">
                                    <label for="searchFilter-{{Name}}">Search options</label>
                                </forge-text-field>
        
                                <div fxLayout="row" fxLayoutAlign="flex-end center">
                                    <forge-icon-button [dense]="compact ? '' : undefined" aria-label="selectAllText(false)"
                                                       (click)="selectAll()" [disabled]="isViewOnly" style="margin-left: 8px;">
                                        <forge-tooltip placement="bottom">{{selectAllText(false)}}</forge-tooltip>
                                        <forge-icon name="checkbox_multiple_marked"></forge-icon>
                                    </forge-icon-button>
                                    <forge-icon-button [dense]="compact ? '' : undefined" aria-label="selectAllText(true)"
                                                       (click)="deselectAll()" [disabled]="isViewOnly"
                                                       id="select-all-button-{{popupId}}" style="margin-left: 8px;">
                                        <forge-tooltip placement="bottom">{{selectAllText(true)}}</forge-tooltip>
                                        <forge-icon name="checkbox_multiple_blank_outline"></forge-icon>
                                    </forge-icon-button>
                                </div>
                            </div>
        
                            <forge-card class="multiselect-list-card--first no-padding" [id]="multiSelectListSelectId"
                                        style="margin-top: 8px; max-height: 25vh;">
                                <forge-scaffold>
                                    <forge-list slot="body" [dense]="compact ? '' : undefined">
                                        <forge-list-item *ngFor="let item of selectList" [value]="item.Key"
                                                         propagate-click="false" [disabled]="isViewOnly">
        
                                            <forge-checkbox slot="start" style="--forge-list-item-leading-margin-right: 0;"
                                                            [disabled]="isViewOnly" attr.aria-label="{{item.Value}}"
                                                            (change)="selectItem(item.Key)" [checked]="isItemChecked(item.Key)">
                                            </forge-checkbox>
        
                                            <truncate-text class="tyl-list-item__text"
                                                           [ngClass]="{'disabled-input': isViewOnly}" [mainText]="item.Value">
                                            </truncate-text>
                                        </forge-list-item>
                                    </forge-list>
                                </forge-scaffold>
                            </forge-card>
                            <forge-button fxLayout="row" fxLayoutAlign="end end" variant="text" (click)="closePopup()"
                                          (keydown)="closeButtonKeyDown($event)" aria-label="Close multiselect"
                                          id="close-button-{{popupId}}">Close
                            </forge-button>
                        </div>
                    </div>
                </div>
            </div>
        </forge-popover>
    </div>
</div>
